import type { HtmlTransform } from '../formatMessage'

/**
 * Heuristic: common legal citation patterns in Salvadoran law.
 * Matches Art. N, Artículo, Código de/Civil/Penal/de Trabajo,
 * Ley, D.L., Decreto Legislativo, inciso, literal, numeral.
 */
const LEGAL_KEYWORDS = /\b(Art\.?\s*\d|Artículo|Código\s+de|Código\s+Civil|Código\s+Penal|Código\s+de\s+Trabajo|Ley\s+\w|D\.L\.\s*\d|Decreto\s+Legislativo|inciso|literal|numeral)/i

/**
 * Post-markdown transform: style blockquotes containing legal
 * references as "legal reference cards" with a distinct border.
 *
 * Also converts fenced code blocks with language "legal" or
 * "articulo" into styled reference divs.
 *
 * Detection is heuristic — checks for common legal keywords.
 * This avoids requiring special syntax from the LLM.
 */
export const legalReference: HtmlTransform = (html) => {
  let result = html.replace(
    /<blockquote>([\s\S]*?)<\/blockquote>/g,
    (match, inner: string) => {
      if (LEGAL_KEYWORDS.test(inner)) {
        return `<blockquote class="marcus-legal-ref">${inner}</blockquote>`
      }
      return match
    },
  )

  result = result.replace(
    /<pre><code class="language-(?:legal|articulo|ley)">([\s\S]*?)<\/code><\/pre>/g,
    '<div class="marcus-legal-ref marcus-legal-code">$1</div>',
  )

  return result
}
